import { render, staticRenderFns } from "./BookRemunerations.vue?vue&type=template&id=64f150f8"
import script from "./BookRemunerations.vue?vue&type=script&lang=js"
export * from "./BookRemunerations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports